import React from "react";
import { Container, Button } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa";
import { useTranslation } from "react-i18next";

import "../App.css";

const RentalHome = ({ cookiesAccepted }: { cookiesAccepted: boolean }) => {
  const { t } = useTranslation();
  const Icon = FaChevronDown as unknown as React.FC;

  const scrollToContent = () => {
    const el = document.getElementById("rental-content-section");
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: y - 100, behavior: "smooth" });
    }
  };

  return (
    <div>
      {/* HERO SECTION */}
      <section
        style={{
          position: "relative",
          height: "100vh",
          overflow: "hidden",
          top: 40,
        }}
      >
        <video
          className="background-video"
          autoPlay
          muted
          loop
          playsInline
          poster="/images/rower2.jpeg" // Placeholder image
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -1,
          }}
        >
          {/* MOBILE VIDEO */}
          <source
            src="/images/videorowery-mobile.webm"
            type="video/webm"
            media="(max-width: 768px)"
          />
          <source
            src="/images/videorowery-mobile.mp4"
            type="video/mp4"
            media="(max-width: 768px)"
          />

          {/* DESKTOP / DEFAULT VIDEO */}
          <source
            src="/images/videorowery.webm"
            type="video/webm"
            media="(min-width: 769px)"
          />
          <source
            src="/images/videorowery.mp4"
            type="video/mp4"
            media="(min-width: 769px)"
          />

          {t("videoProblem")}
          <img src="/images/rower2.jpeg" alt="Tło wypożyczalni" />
        </video>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.4)", // <-- przyciemnia tło
            zIndex: -1,
          }}
        ></div>
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "3rem", fontWeight: "bold" }}>
            {t("rentalTitle")}{" "}
            <span style={{ color: "#F58220" }}>{t("rentalSubtitle")}</span>
          </h1>
          <p style={{ fontSize: "1.2rem" }}>📍 {t("rentalLocation")}</p>
          <p style={{ fontSize: "1.2rem" }}>10:00 - 18:00</p>

          <Button variant="danger" size="lg" href="tel:+48789784647">
            {t("bookBike")}
          </Button>
        </div>

        <div
          className="scroll-arrow"
          onClick={scrollToContent}
          style={{
            position: "absolute",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            cursor: "pointer",
            fontSize: "3rem",
            color: "#FFF",
            zIndex: 2,
          }}
        >
          <Icon />
        </div>
      </section>

      {/* ABOUT SECTION */}
      <Container className="text-center my-5" id="rental-content-section">
        <div className="row mt-5 align-items-center">
          {/* Tekst z ofertą */}
          <div className="col-lg-6 text-center text-lg-start mb-4 mb-lg-0">
            <h2 className="fw-bold mb-3">{t("adventureWithoutEffort")}</h2>
            <p className="text-muted">{t("description")}</p>
            <h3 className="fw-bold mt-4">{t("whatWeOffer")}</h3>
            <ul className="list-unstyled">
              <li>{t("offer1")}</li>
              <li>{t("offer2")}</li>
              <li>{t("offer3")}</li>
              <li>{t("offer4")}</li>
              <li>{t("offer5")}</li>
            </ul>
          </div>

          {/* Zdjęcia: 2 małe po lewej, 1 większe po prawej */}
          <div className="col-lg-6 d-flex flex-column flex-lg-row">
            {/* Lewa kolumna z 2 małymi zdjęciami */}
            <div
              className="d-flex flex-column justify-content-between mb-3 mb-lg-0 me-lg-3"
              style={{ flex: 1 }}
            >
              <img
                src="/images/rower1.jpeg"
                alt="Rower 1"
                className="img-fluid rounded shadow mb-3"
                style={{
                  height: "240px",
                  objectFit: "cover",
                  width: "100%",
                }}
              />
              <img
                src="/images/rower2.jpeg"
                alt="Rower 2"
                className="img-fluid rounded shadow"
                style={{
                  height: "240px",
                  objectFit: "cover",
                  width: "100%",
                }}
              />
            </div>

            {/* Prawa kolumna z jednym dużym zdjęciem */}
            <div style={{ flex: 1 }}>
              <img
                src="/images/rower3.jpeg"
                alt="Rower 3"
                className="img-fluid rounded shadow"
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          </div>
        </div>
      </Container>

      {/* CENNIK SECTION */}
      <Container className="text-center my-5">
        <h2 className="fw-bold mb-4">{t("rentalPricingTitle")}</h2>
        <table
          className="table table-bordered table-striped mx-auto"
          style={{ maxWidth: 600 }}
        >
          <thead>
            <tr>
              <th>{t("rentalTime")}</th>
              <th>{t("rentalPrice")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{t("3hours")}</td>
              <td>{t("3hoursPrice")}</td>
            </tr>
            <tr>
              <td>{t("day")}</td>
              <td>{t("dayPrice")}</td>
            </tr>
          </tbody>
        </table>
        <p className="text-muted">{t("rentalpriceIncludes")}</p>
      </Container>

      {/* MAPA */}
      <Container className="my-5">
        <h2 className="fw-bold text-center mb-4">{t("rentalLocationTitle")}</h2>
        {cookiesAccepted ? (
          <div className="d-flex justify-content-center">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d21202.44256287187!2d20.30478879943557!3d49.425739283457375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473e03213464e3c3%3A0x692c169406b4e29a!2sWypo%C5%BCyczalnia%20rower%C3%B3w%20elektrycznych%20Zadyma!5e0!3m2!1spl!2spl!4v1753006331601!5m2!1spl!2spl"
              width="600"
              height="450"
              style={{ border: 0 }}
              title={"WYPOŻYCZALNIA ROWERÓW ZADYMA"}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        ) : (
          <p className="text-center">
            {t("cookieMessageMapHidden") ||
              "Mapa jest ukryta do momentu zaakceptowania plików cookie."}
          </p>
        )}
      </Container>
    </div>
  );
};

export default RentalHome;
